// extracted by mini-css-extract-plugin
export var body = "FaqLayout-module--body--e03b6";
export var container = "FaqLayout-module--container--dc1e6";
export var nav = "FaqLayout-module--nav--d40aa";